import { X } from 'lucide-react'

/** Small "X" pinned to the top-right of a modal card. Dialogs close only via a
 *  deliberate action (an option button or this X) — backdrop clicks are ignored
 *  so a stray click outside the window can't dismiss it by accident. The parent
 *  card must be a positioned ancestor (the modal cards already are). */
export function ModalCloseButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      className="modal-close-x"
      onClick={onClick}
      aria-label="Cerrar"
      title="Cerrar"
    >
      <X size={18} />
    </button>
  )
}
